// extracted by mini-css-extract-plugin
export default {"greenSpinner":"LoadingSpinner_greenSpinner__1UjJB","spinner":"LoadingSpinner_spinner__NYdrO","orangeSpinner":"LoadingSpinner_orangeSpinner__2FMVp"};